var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "side-nav-panel grid grid__base",
      class: _vm.mainNavigationStateFacet
    },
    [
      _c("div", { staticClass: "side-nav-panel--panel-content-wrapper" }, [
        _c(
          "div",
          { staticClass: "side-nav-panel--panel" },
          [
            _c(
              "div",
              { staticClass: "side-nav-panel--panel-content" },
              [
                _c("nav-panel-content", {
                  attrs: { items: _vm.items, facets: ["side-nav"] }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "meta-nav",
              _vm._b(
                {
                  staticClass: "side-nav-panel--metanav",
                  attrs: { facets: ["mobile"] }
                },
                "meta-nav",
                _vm.metanav,
                false
              )
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba2e4d8", { render: render, staticRenderFns: staticRenderFns })
  }
}